// UI texts: the wardrobe (docs/OUTFITI_garderoba.md)
export default {
  /** 29. 9. 2026: before the wardrobe opens (level 5 or the first outfit). */
  closed: {
    title: 'Appearance opens at level {n}',
    body: 'Or earlier: complete a set in one rarity in the Collection book and its outfit unlocks.',
  },
  title: 'Appearance',
  back: 'Survivor',
  sub: 'Collect all five pieces of a set in one rarity to unlock its outfit. Looks only: stats, Power and fights stay the same.',
  error: 'Could not load the wardrobe.',
  button: 'Appearance',
  newOutfit: 'New outfit unlocked',
  base: 'Survivor',
  baseSub: 'Your base look',
  wear: 'Wear',
  wearing: 'Wearing',
  animated: 'Animated',
  new: 'New',
  setRow: '{name} · {n}/4 outfits',
  setRowCount: '{n}/4 outfits',
  piecesN: '{n}/5 pieces',
  locked: '{rarity} · {n}/5 pieces',
  lockedAlt: '{name}, locked',
  pieces: 'Pieces for {name}',
  piecesSub: 'All five pieces in {rarity} unlock this outfit. Pieces you ever owned count, even if they are gone now.',
  piecesSubCommon: 'All five pieces in Common or Uncommon unlock this outfit. Pieces you ever owned count, even if they are gone now.',
  have: 'In your Collection book',
  needs: 'Needs the {rarity} version',
  needsCommon: 'Needs the Common or Uncommon version',
  lockedPreview: 'Locked: {n}/5 pieces',
  woreToast: 'Wearing {name}',
  baseToast: 'Back to your base look',
  /** 20. 10. 2026 (owner): Match my gear, the default look. */
  match: {
    label: 'Match my gear',
    sub: 'Follows your armor',
    default: 'Default',
    toast: 'Your look now matches your gear',
    how: 'Wear 3 or more pieces of one set: your survivor wears that set’s outfit in the rarity most of the pieces have. Only outfits you unlocked, up to the highest one.',
    shows: 'Showing {name}: {n} {set} pieces worn.',
    capped: 'Your {set} pieces are mostly {rarity}; that outfit is not unlocked yet, so it shows {name}.',
    lockedSet: 'You wear {n} {set} pieces, but no {set} outfit is unlocked yet: base look.',
    noSet: 'No set with 3 pieces worn: base look.',
  },
} as const;
